import {
  REQUEST_RARE_DISEASE,
  RESPONSE_RARE_DISEASE,
  FAILURE_RARE_DISEASE
} from "../../actions/types";
import { combineReducers } from "redux";
import network from "./network";
import tweets from "./tweets";

const initialState = {
  isFetching: false,
  results: {},
  error: false,
  isInitalScreen: true
};

const setFetching = (state, action) => {
  let terms = action.payload.terms || [];
  return {
    ...state,
    isFetching: true,
    results: {},
    isInitalScreen: false,
    terms: terms
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: {}
  };
};

const setResults = (state, action) => {
  let results = action.payload || {};
  results = results.results || {};
  
  return {
    ...state,
    isFetching: false,
    error: false,
    results
  };
};

const events = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_RARE_DISEASE:
      return setFetching(state, action);
      break;

    case RESPONSE_RARE_DISEASE:
      return setResults(state, action);

    case FAILURE_RARE_DISEASE:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};

export default combineReducers({
  events,
  network,
  tweets
});
